/**
 * AI erişim kapısı — ÜÇ ayrı koşul ve üçü de ayrı ayrı sorulur.
 *
 *   1. Kullanıcının yetkisi: `user.canUseAiChat` (giriş yanıtı; Kullanıcılar ekranından
 *      yönetici açıp kapatıyor). Yoksa AI'a ait hiçbir şey çizilmez — düğme de, istek de.
 *   2. Sunucuda Claude Code kurulu ve çalışır: `/api/claudecode/status`. Kurulum yoksa
 *      düğmeyi göstermek, basınca hiçbir şey olmayan bir düğme demekti.
 *   3. Token kotası: merkezî havuzda pay kalmamışsa panel açılır ama yazma kapalıdır ve
 *      sebebi yazılıdır (masaüstü de böyle davranıyor).
 *
 * Yetkisi olmayan kullanıcı için durum/kota uçlarına İSTEK ATILMAZ: yetkisiz kullanıcıya
 * ait boş isteklerle sunucuyu yormanın ve 403'leri log'a doldurmanın anlamı yok.
 */
import { useEffect } from 'react';
import { useAuthStore } from '@/entities/session/model/authStore';
import { useAiQuota, useAiStatus } from '../api/aiApi';
import { useAiStore } from './aiStore';

export interface AiAccess {
  /** Kullanıcının yetkisi var mı (Users.CanUseAiChat) */
  canUse: boolean;
  /** Sunucuda Claude Code çalışıyor mu */
  serverReady: boolean;
  /** Düğme/panel gösterilsin mi */
  available: boolean;
  /** Kota tükendi mi (panel açılır, yazma kapalı) */
  quotaExceeded: boolean;
  checking: boolean;
  /**
   * Yetki var ama sunucu hazır değil ve kullanıcı SİSTEM ROLÜNDE.
   *
   * "AI sohbetim açık, neden görmüyorum?" sorusunun tek yanıtı sunucu yapılandırmasında
   * ve bunu ancak yönetici düzeltebiliyor. Normal kullanıcıya altyapı ayrıntısı
   * göstermenin anlamı yok — onda düğme hiç çıkmıyor; yöneticide çıkıyor ve panel
   * sebebi söylüyor.
   */
  showDiagnostics: boolean;
}

export function useAiAccess(): AiAccess {
  const user = useAuthStore((s) => s.user);
  const canUse = !!user?.canUseAiChat;

  const status = useAiStatus(canUse);
  const serverReady = status.data?.available === true;

  const quota = useAiQuota(user?.userId ?? null, canUse && serverReady);
  const setQuota = useAiStore((s) => s.setQuota);
  const quotaExceeded = useAiStore((s) => s.quotaExceeded);

  // Kota store'a taşınır: panel ve besteci tek kaynaktan okur, akış sonunda da aynı
  // yerden güncellenir.
  useEffect(() => {
    if (quota.data) setQuota(quota.data);
  }, [quota.data, setQuota]);

  /*
   * Yetki KAYBEDİLİRSE panel kapatılır. Yönetici yetkiyi kaldırdığında kullanıcının
   * açık panelinde sohbete devam edebilmesi, yetkinin bir anlamı kalmaması demekti.
   */
  const open = useAiStore((s) => s.open);
  const reset = useAiStore((s) => s.reset);
  useEffect(() => {
    if (open && !canUse) reset();
  }, [open, canUse, reset]);

  return {
    canUse,
    serverReady,
    available: canUse && serverReady,
    quotaExceeded,
    checking: canUse && status.isLoading,
    showDiagnostics: canUse && !serverReady && !status.isLoading && !!user?.isSysRol,
  };
}
